import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useLocation } from "react-router-dom";

// Icons
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

// Components
import CustomDrawer from "../components/CustomDrawer";
import EmailMarketingResult from "../components/Emailmarketingresult.jsx";
import EmailMarketingCampaign from "../components/EmilMrketingCampane.jsx";
import AnalyticsSeasions from "../components/AnalyticsSeasions";
import AnalyticsMain from "../components/AnalyticsMain";
import Layout from "../components/layout/Layout";

import axios from "axios";
import config from "../config.js";

const MarketingDashboard = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [newMarketValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  
  const [emailData, setEmailData] = useState([]);
  const [analyticsData, setAnalyticsData] = useState([]);
  const [sessionsData, setSessionsData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const location = useLocation();
  const { name } = location.state || {};
  const { API_BASE_URL } = config;
  
  // Fetch data for all components
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/MarketingworkbookToJson`);
        
        // Check if the data exists and has the Google property
        if (response.data && response.data.data && response.data.data.Google) {
          const googleData = response.data.data.Google;
          setEmailData(googleData);
          setAnalyticsData(googleData);
          setSessionsData(googleData);
          setCampaignData(googleData);
        } else {
          console.error("Invalid data structure:", response.data);
          setError(new Error("Invalid data structure"));
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);
  
  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Component to safely render children
  const SafeRender = ({ children, fallback = "Loading..." }) => {
    try {
      return children;
    } catch (error) {
      console.error("Component rendering error:", error);
      return <div className="error-container">{fallback}</div>;
    }
  };

  return (
    <Layout>
      <main>
        <div>
          {name && <h1 className="ms-5 text-warning">{name}</h1>}
          
          {/* Control buttons */}
          <Box
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              m: 5,
              zIndex: 1300,
            }}
          >
            <ButtonGroup
              sx={{
                marginTop: 3,
                marginLeft: 7,
                justifyItems: "center",
                backgroundColor: "#FD6262",
              }}
              variant="contained"
              aria-label="Basic button group"
            >
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  display: "flex",
                  justifyItems: "center",
                  alignItems: "center",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
              >
                <RemoveIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
              >
                <AddIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
                onClick={handleDownloadClick}
              >
                <ArrowCircleDownIcon />
              </Button>
              <Button
                sx={{
                  backgroundColor: "#FD6262",
                  "&:hover": { backgroundColor: "#FF4D4D" },
                }}
                onClick={handleDrawerToggle}
              >
                <RemoveRedEyeIcon />
              </Button>
            </ButtonGroup>
          </Box>

          <CustomDrawer
            isDrawerOpen={isDrawerOpen}
            handleDrawerToggle={handleDrawerToggle}
          />

          {/* Main content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: "100%",
              paddingTop: "64px",
              paddingRight: isDrawerOpen ? "20%" : "0px",
              transition: "padding-right 0.3s ease",
            }}
          >
            <Toolbar />
            <Box component="section" mt={4}>
              <Container>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#e0e0e0", height: "100%" }}
                      elevation={3}
                    >
                      <SafeRender fallback="Email Marketing Results Unavailable">
                        <EmailMarketingResult data={emailData} />
                      </SafeRender>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#d0d0d0", height: "100%" }}
                      elevation={3}
                    >
                      <SafeRender fallback="Analytics Data Unavailable">
                        <AnalyticsMain data={analyticsData} />
                      </SafeRender>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#c0c0c0", height: "100%" }}
                      elevation={3}
                    >
                      <SafeRender fallback="Analytics Sessions Unavailable">
                        <AnalyticsSeasions data={sessionsData} />
                      </SafeRender>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Paper
                      sx={{ padding: 4, backgroundColor: "#b0b0b0", height: "100%" }}
                      elevation={3}
                    >
                      <SafeRender fallback="Email Campaign Data Unavailable">
                        <EmailMarketingCampaign data={campaignData} />
                      </SafeRender>
                    </Paper>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </Box>
        </div>
      </main>
    </Layout>
  );
};

export default MarketingDashboard;
